import { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDrag } from 'react-dnd-cjs';
import { getEmptyImage } from 'react-dnd-html5-backend-cjs';

import { DraggableCard } from 'components';
import { dragItems } from 'constants/general';

const SidebarDraggableItem = (props) => {
	const { containerId, state, onClick } = props;

	const [{ isDragging }, drag, preview] = useDrag({
		item: {
			type: dragItems.CAMPAIGN_STATE,
			payload: state,
			containerId,
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	});

	const handleClick = useCallback(() => {
		onClick(state.id);
	}, [state, onClick]);

	useEffect(() => {
		preview(getEmptyImage(), { captureDraggingState: true });
	}, [preview]);

	return (
		<div ref={drag} style={{ opacity: isDragging ? 0.3 : 1 }} onClick={handleClick}>
			<DraggableCard text={state.shortDescription} />
		</div>
	);
};

SidebarDraggableItem.propTypes = {
	containerId: PropTypes.number,
	onClick: PropTypes.func,
	state: PropTypes.object,
};

export default SidebarDraggableItem;
